import httpBuildQuery from '../../src/procedures/http-build-query';
import apiPaths from '../api-paths.js';

export default {
  store(payload) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/evidences/closed-months`, payload);
  },
  update({ id, payload }) {
    return axios.put(`${ apiPaths.BOOKKEEPING }/evidences/closed-months/${ id }`, payload);
  },
  processClosedMonthRequests({ id }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/closed-month/${ id }/process-closed-month-requests`);
  },
  checkIfExists({ year, month }) {
    const query = httpBuildQuery({ year, month });
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/closed-months/exists${ query }`);
  },
  getTaxSummaryPreflight({ year, month, evidenceType, pitSettlementsPeriodType } = {}) {
    const query = httpBuildQuery({
      year,
      month,
      evidencetype: evidenceType,
      pitsettlementsperiodtype: pitSettlementsPeriodType,
    });
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/closed-months/tax-statements-preflight${ query }`);
  },
  getTaxSummary({ closedMonthId }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/closed-months/${ closedMonthId }/tax-summary`);
  },
  getTaxSummaryForPeriod({ period }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/evidences/closed-months/tax-summary/by-period`, {period});
  },
  getHistoricalChanges({ closedMonthId }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/closed-months/${ closedMonthId }/tax-summary-historical-changes`);
  },
};
